function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { ApiConstants, ThunkHelper } from 'invision-core';
export var RETRIEVE_PRODUCT_DETAIL_CONSTANTS = {
  BEGIN: 'RETRIEVE_PRODUCT_DETAIL_BEGIN',
  SUCCESS: 'RETRIEVE_PRODUCT_DETAIL_SUCCESS',
  FAILURE: 'RETRIEVE_PRODUCT_DETAIL_FAILURE'
};
var RETRIEVE_PRODUCT_DETAIL_EVENTS = [RETRIEVE_PRODUCT_DETAIL_CONSTANTS.BEGIN, RETRIEVE_PRODUCT_DETAIL_CONSTANTS.SUCCESS, RETRIEVE_PRODUCT_DETAIL_CONSTANTS.FAILURE];
export var retrieveProductDetailPromise = function retrieveProductDetailPromise(dispatch, customerId, lockerItemId) {
  return ThunkHelper(dispatch, RETRIEVE_PRODUCT_DETAIL_EVENTS, {
    method: 'post',
    url: 'SubscriberManagement/RetrieveLockerItem',
    data: {
      Id: lockerItemId
    },
    headers: _defineProperty({}, ApiConstants.SUBSCRIBER_ID_HEADER, customerId)
  });
};
export var retrieveProductDetail = function retrieveProductDetail(customerId, lockerItemId) {
  return function (dispatch) {
    return retrieveProductDetailPromise(dispatch, customerId, lockerItemId);
  };
};
export var RETRIEVE_ORDER_FOR_LOCKER_DETAIL_CONSTANTS = {
  BEGIN: 'RETRIEVE_ORDER_FOR_LOCKER_DETAIL_BEGIN',
  SUCCESS: 'RETRIEVE_ORDER_FOR_LOCKER_DETAIL_SUCCESS',
  FAILURE: 'RETRIEVE_ORDER_FOR_LOCKER_DETAIL_FAILURE'
};
var RETRIEVE_ORDER_FOR_LOCKER_DETAIL_EVENTS = [RETRIEVE_ORDER_FOR_LOCKER_DETAIL_CONSTANTS.BEGIN, RETRIEVE_ORDER_FOR_LOCKER_DETAIL_CONSTANTS.SUCCESS, RETRIEVE_ORDER_FOR_LOCKER_DETAIL_CONSTANTS.FAILURE];
export var retrieveOrderForLockerDetailPromise = function retrieveOrderForLockerDetailPromise(dispatch, customerId, orderId) {
  return ThunkHelper(dispatch, RETRIEVE_ORDER_FOR_LOCKER_DETAIL_EVENTS, {
    method: 'post',
    url: 'SubscriberManagement/RetrieveOrder',
    data: {
      OrderId: orderId
    },
    headers: _defineProperty({}, ApiConstants.SUBSCRIBER_ID_HEADER, customerId)
  });
};
export var retrieveOrderForLockerDetail = function retrieveOrderForLockerDetail(customerId, orderId) {
  return function (dispatch) {
    return retrieveOrderForLockerDetailPromise(dispatch, customerId, orderId);
  };
};
export var GRANT_ADDITIONAL_RIGHTS_CONSTANTS = {
  BEGIN: 'GRANT_ADDITIONAL_RIGHTS_BEGIN',
  SUCCESS: 'GRANT_ADDITIONAL_RIGHTS_SUCCESS',
  FAILURE: 'GRANT_ADDITIONAL_RIGHTS_FAILURE'
};
var GRANT_ADDITIONAL_RIGHTS_EVENTS = [GRANT_ADDITIONAL_RIGHTS_CONSTANTS.BEGIN, GRANT_ADDITIONAL_RIGHTS_CONSTANTS.SUCCESS, GRANT_ADDITIONAL_RIGHTS_CONSTANTS.FAILURE];
var grantAdditionalRightsPromise = function grantAdditionalRightsPromise(dispatch, customerId, options) {
  return ThunkHelper(dispatch, GRANT_ADDITIONAL_RIGHTS_EVENTS, {
    method: 'post',
    url: 'SubscriberManagement/GrantAccessRights',
    headers: _defineProperty({}, ApiConstants.SUBSCRIBER_ID_HEADER, customerId),
    data: {
      Id: options.Id,
      ActionCode: options.ActionCode,
      AccessRequests: options.GrantAccessCount,
      AccessHours: options.GrantTimeRemaining,
      Licenses: options.GrantLicenseCount
    }
  });
};
export var grantAdditionalRights = function grantAdditionalRights(customerId, options) {
  return function (dispatch) {
    return grantAdditionalRightsPromise(dispatch, customerId, options);
  };
};